import { render, staticRenderFns } from "./TabTransactions.vue?vue&type=template&id=33d84225&scoped=true&"
import script from "./TabTransactions.vue?vue&type=script&lang=js&"
export * from "./TabTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d84225",
  null
  
)

export default component.exports